/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESDocumentService.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_ACESDBS_FILES = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESDOCUMENTSERVICE/POST_ACESDBS_FILES`
);

const GET_ACESDBS_FILES_BY_FILE_ID = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESDOCUMENTSERVICE/GET_ACESDBS_FILES_BY_FILE_ID`
);

const DELETE_ACESDBS_FILES_BY_FILE_ID = ReduxUtils.generateActionTypes(
  'ua-library',
  `ACESDOCUMENTSERVICE/DELETE_ACESDBS_FILES_BY_FILE_ID`,
  'DELETE'
);

export { POST_ACESDBS_FILES, GET_ACESDBS_FILES_BY_FILE_ID, DELETE_ACESDBS_FILES_BY_FILE_ID };
